<template>
    <div class="text-wrapper">
        <p class="warning-text"><span class="red">If you do not receive an email confirmation, the registration has failed.</span></p>
        <p>
            <b>Cancellation policy</b>
            For your hotel room:<br/>
            <ul>
                <li>Free cancellation between 60 and 30 days before arrival</li>
                <li>25% charge between 29 and 14 days before arrival</li>
                <li>50% charge between 13 and 8 days before arrival</li>
                <li>100% charge within 7 days or less before arrival</li>
            </ul>
            For catering:<br/>
            <ul>
                <li>100% charge (€115 for both days; €75 for Thursday; €40 for Friday) within 7 days or less before arrival</li>
            </ul>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'v-intro-text'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .text-wrapper{
        h1{
            font-size:1.25em;
        }
        img{
            max-width:100%;
            margin:0 auto;
        }
        .img-center{
            text-align:center;
        }
        .warning-text{
            //text-align:center;
            font-size:1.15em;
            .red{
                color:#f90202;
                a{
                    color:#f90202;
                }
            }
        }
        font-size:1.15em;
    }
</style>
